import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62e712ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { ref } from 'vue'

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Button from '@/popup/components/shared/Button.vue'
import { Description, Label } from '@/popup/components/shared/Form/Form'
import DisplayAccount from '@/popup/components/Modal/DisplayAccount.vue'
import ModalTransition from '@/popup/components/shared/Modal/ModalTransition.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Develop',
  setup(__props) {

const modalOpen = ref(false)

const openModal = () => {
  modalOpen.value = true
}

const closeModal = () => {
  modalOpen.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Label), {
      "extra-class": "is-title mb-2",
      label: _ctx.$t('settings.developer.display.title')
    }, null, 8 /* PROPS */, ["label"]),
    _createVNode(_unref(Description), {
      description: _ctx.$t('settings.developer.display.description')
    }, null, 8 /* PROPS */, ["description"]),
    _createVNode(Button, {
      variant: "secondary",
      "is-full-width": true,
      class: "mt-2",
      "custom-class": "items-center",
      onClick: openModal,
      "data-testid": "backup-button"
    }, {
      default: _withCtx(() => [
        _createVNode(SvgIcon, {
          class: "mr-2",
          name: "key-outline"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.developer.display.button_title')), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    (modalOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            _createVNode(ModalTransition, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(DisplayAccount, { "on-cancel": closeModal }, null, 512 /* NEED_PATCH */), [
                  [_vShow, modalOpen.value]
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})